<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input v-model="role.label" label="Name" v-uppercase></base-input>
      </div>
    </div>
    <base-button md type="primary" @click="onSubmit()">Save</base-button>
  </div>
</template>
<script>
import { mapState,mapActions, mapGetters } from 'vuex';
export default {
     directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {
     
    };
  },
   
   computed:{
     ...mapState("role",["role"]),
    // ...mapGetters({role:"role/getRole"})
   },

   methods:{
     ...mapActions({saveRole:'role/saveRole',updateRole:"role/updateRole",getRoles : "role/getRoles"}),
     onSubmit(){
      if (this.role.roleId) {
        this.updateRole().then(res => {
          this.$notify({
            message: "Role Updated Succesfully!",
            type: "success",
            title:"Succes"
          });
          this.$emit("close");
          this.getRoles();
        });
      } else {
        this.saveRole().then(res => {
          this.$notify({
            message: "Role Created Succesfully!",
            type: "success",
            title: "Success"
          });
           this.$emit("close");
          this.getRoles();
        });
      }
    }
   }
};
</script>

